import { c as _c } from "react/compiler-runtime";
import type { TooltipProps } from '@mui/material';
import { Tooltip } from '@mui/material';
import classNames from 'classnames';
export const HelpIcon = t0 => {
  const $ = _c(9);
  const {
    title,
    alwaysVisible: t1,
    tooltipProps,
    className
  } = t0;
  const alwaysVisible = t1 === undefined ? false : t1;
  const t2 = !alwaysVisible;
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = classNames("material-symbols-help-outline-rounded h-[20px] w-[20px] p-[2px] leading-none", {
      "opacity-0 group-hover/help:opacity-100 transition-opacity": t2
    }, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <i className={t3} />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4 || $[6] !== title || $[7] !== tooltipProps) {
    t5 = <Tooltip title={title} {...tooltipProps}>{t4}</Tooltip>;
    $[5] = t4;
    $[6] = title;
    $[7] = tooltipProps;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};